import React from "react";

export const OfflineEventTableHead = ({
  displayGridProps,
  // parent,
  // pathname,
}) => {
  // const [extra, setExtra] = React.useState(
  //   pathname.includes("offline-events-booked") ||
  //     pathname.includes("offline-events-history")
  //     ? true
  //     : false
  // );
  return (
    <React.Fragment>
      <thead className="sd_table_thead">
        <tr>
          {displayGridProps ? null : (
            <th className="request-number" style={{ width: "5%" }}>
              <p className="font_16_r">Request Type</p>
            </th>
          )}
          <th className="total-pax" style={{ width: "18%" }}>
            {displayGridProps ? (
              <p className="font_16_r">Name Request Number</p>
            ) : (
              <p className="font_16_r">
                Name /<br />
                Request Number
              </p>
            )}
          </th>
          <th
            className={displayGridProps ? "location-table" : "location"}
            style={{ width: "14%" }}
          >
            <p className="font_16_r">Total PAX</p>
          </th>
          <th className="date-time-timer" style={{ width: "14%" }}>
            <p className="font_16_r">Date / Time</p>
            {displayGridProps ? null : <p className="font_16_r">Timer</p>}
            {displayGridProps ? null : <p className="font_10_r">(HH:MM:SS)</p>}
          </th>
          {displayGridProps ? null : (
            <th
              className={displayGridProps ? "location-table" : "location"}
              style={{ width: "14%" }}
            >
              <p className="font_16_r">Payment Status</p>
            </th>
          )}

          {displayGridProps ? null : (
            <th className="action text-center" style={{ width: "35%" }}>
              <p className="font_16_r">Action</p>
            </th>
          )}
        </tr>
      </thead>
    </React.Fragment>
  );
};

export const EventTableManagementHeadRight = () => {
  return (
    <React.Fragment>
      <thead className="sd_table_thead">
        <tr>
          <th>
            <p className="font_16_m">Table Management</p>
          </th>
        </tr>
      </thead>
    </React.Fragment>
  );
};
